import React, { useEffect, useState } from "react";
//import AgregarObra from "./AgregarObra";
import '../../CSS/Empleados.css'
import { getPermission, URIMG } from "../../Conexiones/Conexion";
import { useNavigate } from "react-router";
import { FaArrowLeftLong } from "react-icons/fa6";
import { deleteApi, getApi, putApi, putApiImg } from "../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningModal, warningToast } from "../../Utils/AlertMessage";
import { Button, CloseButton, Modal } from "react-bootstrap";
import Select from 'react-select';
import Loading from '../../Utils/Loading';

function TablaObras() {
    const [obra, setObra] = useState([]);
    const [tablaObra,setTablaObra]=useState([]);
    const [busqueda,setBusqueda] = useState ('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const navigate = useNavigate();
    const uri = 'obras/';
    const [isLoading,setIsLoading]=useState(false);

    useEffect(() => {
        const getObras = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,13);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setObra(res.data);
                        setTablaObra(res.data);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        };
        getObras();
    }, [navigate,idUsuario]);

    const getObras = async () => {
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setObra(res.data);
                setTablaObra(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };

    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = tablaObra.filter((elemento)=> {
            if  (elemento.nombreObra.toString().toLowerCase().includes(textoIngresado.toLowerCase())){  
                return elemento;
            }
            return resultadoBusqueda;
        });
        setObra(resultadoBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos')
    }

    const modalEliminar = (id) => {
        warningModal("¿Quieres eliminar esta obra?")
        .then(async (result) => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="Registro eliminado"){
                        getObras();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        });
    };

    const [obrasTipos,setObrasTipos]=useState([])
    const getTipos = async () =>{
        const endpoint = 'tiposObra/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setObrasTipos(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const [isSaving, setSaving] = useState(false);
    const [idObra,setIdObra] = useState('');
    const [nombreObra,setNombreObra] = useState ('');
    const [clienteObra,setClienteObra] = useState ('');
    const [direcObra,setdirecObra] = useState ('');
    const [fechaInicio,setFechaI]=useState('');
    const [fechaFinal,setFechaF]=useState('');
    const [idTipo,setIdTipo]=useState('');
    const [tipo,setTipo]=useState('');
    const [imgObra,setImgObra]=useState('');
    const [imagenObra,setimagenObra] = useState (null);

    //Editar
    const [showUd, setShowUd] = useState(false);
    const handleCloseUd = () => setShowUd(false);
    const handleShowUd = () => setShowUd(true);
    const closeUpd = () =>{
        handleCloseUd();
        setIdObra('');
        setNombreObra('');
        setClienteObra('');
        setdirecObra('');
        setFechaI('');
        setFechaF('');
        setIdTipo('');
        setTipo('');
        setImgObra('');
        setimagenObra(null);
    }
    const showUpd = async (ido,nomo,cli,dir,fei,fef,idt,nomt,img) => {
        const id = ido;
        const nomObr = nomo;
        const cliente = cli;
        const direccion = dir;
        const fechaI = fei;
        const fechaF = fef;
        const idTip = idt;
        const nomTip = nomt;
        const imgO = img;
        await getTipos();
        setIdObra(id);
        setNombreObra(nomObr);
        setClienteObra(cliente);
        setdirecObra(direccion);
        setFechaI(fechaI);
        setFechaF(fechaF);
        setIdTipo(idTip);
        setTipo(nomTip);
        setImgObra(imgO);
        handleShowUd();
    }
    const handleSelectChange = (event) =>{
        setIdTipo(event.value);
    }
    const update= async (e) => {
        setSaving(true);
        e.preventDefault()
        if(nombreObra.trim().length === 0 | direcObra.trim().length === 0 | clienteObra.trim().length === 0 | tipo === ''){
            warningToast('CAMPOS VACIOS','LLENE TODOS LOS CAMPOS');
        }else{
            if (imagenObra === null) {
                const endpoint = uri + idObra;
                const data = {nombreObra:nombreObra,clienteObra:clienteObra,direccionObra:direcObra,fechaInicio:fechaInicio,fechaFinal:fechaFinal,idTObra:idTipo }
                const res = await putApi(endpoint,data);
                if(res.status === 1){
                    if(res.data.message==="¡Registro actualizado correctamente!"){
                        closeUpd();
                        getObras();
                        successToast("EDITADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                const formdata = new FormData();
                formdata.append("image", imagenObra);
                formdata.append("name", nombreObra);
                formdata.append("direccion", direcObra);
                formdata.append("cliente", clienteObra);
                formdata.append("fechaI", fechaInicio);
                formdata.append("fechaF", fechaFinal);
                formdata.append("obraTipo", idTipo);
                const endpoint = uri + idObra;
                const res = await putApiImg(endpoint,formdata);
                if(res.status === 1){
                    if(res.data.message==="¡Registro actualizado correctamente!"){
                        closeUpd();
                        getObras();
                        successToast("EDITADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        }
        setSaving(false);
    }

    return (
        <div className='empleados' >
            {
                isLoading ?
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">gestión de obras</label>
                    </div>
                    <div className='divbotonE' >                                                                                             
                        <div className='botonE'  style={{display:'flex', justifyContent:'end',marginBlockEnd:"20px"}}>
                            <input className="form-control " value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Search" aria-label="Search"/>
                        </div>
                    </div>
                    {
                        obra.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA" >
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered ">
                                        <thead className="encabezado">
                                            <tr >
                                                <th > OBRA </th>
                                                <th>CLIENTE</th>
                                                <th> DIRECCION </th>
                                                <th> FECHA INICIO</th>
                                                <th> FECHA FINAL</th>
                                                {/*<th> ADMINISTRADOR</th>*/}
                                                <th> TIPO </th>
                                                <th> PISOS </th>
                                                <th style={{width:'15vw'}}> ACCIONES </th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {obra.map(dato => {
                                                return (
                                                    <tr key={dato.idObra}>
                                                        <td valign="middle" className="text-uppercase">{dato.nombreObra}</td>
                                                        <td valign="middle" className="text-uppercase">{dato.clienteObra}</td>
                                                        <td valign="middle" className="text-uppercase">{dato.direccionObra}</td>
                                                        <td valign="middle" className="text-uppercase">{dato.fechaInicio}</td>
                                                        <td valign="middle" className="text-uppercase">{dato.fechaFinal}</td>
                                                        {/*<td className="text-uppercase">{dato.nombreEmp }</td>*/}
                                                        <td valign="middle" className="text-uppercase">{dato.nombreTipoObra}</td>
                                                        <td valign="middle" className="text-uppercase">{dato.pisos}</td>
                                                        <td>
                                                            <div>
                                                                <div className="btn iconoH" onClick={() => showUpd(dato.idObra,dato.nombreObra,dato.clienteObra,dato.direccionObra,dato.fechaInicio,dato.fechaFinal,dato.idTObra,dato.nombreTipoObra,dato.imagenObra)} style={{margin:'5px'}}>
                                                                    <span className="bi bi-pen" title="EDITAR"></span>
                                                                </div>                                            
                                                                <div className="btn iconoH" style={{margin:'5px'}} onClick={() => modalEliminar(dato.idObra)}>
                                                                    <span className="bi bi-trash" title="ELIMINAR"></span>
                                                                </div>                                                                    
                                                                </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }

                    {/*EDITAR OBRA*/}
                    <Modal show={showUd} onHide={handleCloseUd} id="modal-editar-obra">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR OBRA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={closeUpd} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left',height:'60vh', overflowY:"scroll" }}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" > nombre de la obra</label>
                                    <input type="text" className="form-control" value={nombreObra} onChange={(e)=>setNombreObra(e.target.value)}  aria-describedby="basic-addon1"/>   
                                </div>
                                <div className=" mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" >dirección</label>
                                    <input type="text" className="form-control" value={direcObra} onChange={(e)=>setdirecObra(e.target.value)}  aria-describedby="basic-addon1"/>   
                                </div>
                                <div className=" mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" >cliente</label>
                                    <input type="text" className="form-control" value={clienteObra} onChange={(e)=>setClienteObra(e.target.value)}  aria-describedby="basic-addon1"/>   
                                </div>
                                <div className=" mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" >fecha de inicio</label>
                                    <input type="date" className="form-control" value={fechaInicio} onChange={(e)=>setFechaI(e.target.value)}    aria-describedby="basic-addon1"/>   
                                </div>
                                <div className=" mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" >fecha  final</label>
                                    <input type="date" className="form-control" value={fechaFinal} onChange={(e)=>setFechaF(e.target.value)}    aria-describedby="basic-addon1"/>   
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" > tipo de obra</label>
                                    <Select
                                        classNamePrefix="select"
                                        defaultValue={{ label: tipo, value: idTipo }}
                                        required
                                        options={obrasTipos.map(tip=>({label:tip.nombreTipoObra,value:tip.idTipoObra}))}
                                        onChange={handleSelectChange}
                                    />
                                </div>
                                <div className=" mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" >imagen</label>
                                    <input className="form-control" type="file"   onChange={(e)=>setimagenObra(e.target.files[0])}  />
                                </div>
                                <div className=" mb-3">
                                    <div style={{textAlign:"center",}}>
                                        <img src={imagenObra === null ? URIMG + imgObra:URL.createObjectURL(imagenObra)} width={'50%'} alt={imgObra}/>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={closeUpd}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default TablaObras;
